import { palette } from '@dev/ee-components';
import styled from 'styled-components';

export const StepContentWrapper = styled.div`
    margin-left: 4px;
`;

export const StepContentFooter = styled.div`
    margin-top: 24px;
    border-top: 1px solid ${palette.gray[3]};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: end;
    gap: 40px;
    padding-top: 39px;
`;
